import draggable from 'vuedraggable'
import MaterialResource from 'components/admin/courseMaterial/MaterialResource';
import MaterialExam from 'components/admin/courseMaterial/MaterialExam';
import MaterialProject from 'components/admin/courseMaterial/MaterialProject';
import leasonTemplate from './leasonTemplate';
import lessonBatchTemplate from "./lessonBatchTemplate";
import _ from "underscore";
import {course} from '@/utils/apis'

export default {
    name: "QualityCourseCreate",
    display: "Clone",
    components: {
        draggable,
        leasonTemplate,
        lessonBatchTemplate,
        MaterialExam,
        MaterialProject,
        MaterialResource
    },
    props: ['courseId'],
    data() {
        return {
            //添加/编辑的title类型
            titleType: '',
            //弹窗的类型：add、edit等
            distinguishBtn: 0, //新增类型：0:章； 1：节
            //是否显示添加章节弹窗
            dialogAddZhang: false,
            //添加章节表单
            addZhangForm: {
                name: ''
            },
            rules: {
                name: [
                    {required: true, message: '请输入章标题', trigger: 'blur'},
                    {min: 3, max: 20, message: '长度在3到5个字符', trigger: 'blur'}
                ]
            },
            //章节数据
            chapters: [],
            //右侧默认显示的页面
            tabName: 'resources',
            showDialogMp4: false,
            videoSrc: null,
            courseType: 1,
            courseName: '',
            id: null,
            curMode: '0',
            editIndex: null,
            materialCheckeds: [],
            examCheckeds: [],
        }
    },
    created() {
        if (this.courseId != undefined) {
            this.getEditData();
        }
    },
    mounted() {
    },
    methods: {
        getEditData(){
            let param = {
                id: this.courseId
            }
            course(param).then((res) => {
                if (res.code == 200) {
                    this.chapters = res.data.course_resources;
                }
            }).catch((err) => {
                console.error(err)
            })
        },
        setSecIndex(val) {
            this.$refs.materials.initChecks();
            this.editIndex = val;
        },
        getMaterialRes(val) {
            let indexArr = this.editIndex.split('|');
            let sectionIns = this.chapters[indexArr[0]].child[indexArr[1]];
            let resourceArr = sectionIns.child;
            sectionIns.child = _.union(sectionIns.child, val);
            console.log(sectionIns, 8888)
        },
        //添加章/节按钮
        addZhang(command) {
            this.titleType = '0';
            this.distinguishBtn = 0;
            this.dialogAddZhang = !this.dialogAddZhang;
        },
        addJie() {
            this.titleType = '1';
            this.distinguishBtn = 1;
            this.dialogAddZhang = !this.dialogAddZhang;
        },
        onAdd(evt) {
            evt.target.className = 'move-area';
        },
        resourcePreview(file_path, file_type) {
            let videoIns = document.getElementById("videoIns");
            if (file_type === "mp4") {
                this.showDialogMp4 = true;
                this.videoSrc = file_path;
            } else {
                window.open(file_path);
            }
        },
        resetAddZhangForm() {
            this.$refs['addZhangForm'].resetFields();
            this.addZhangForm.name = '';
        },
        closeDialogMp4() {
            this.showDialogMp4 = false;
        },
        submitZhangForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.distinguishBtn === 0) {
                        let chapter = {
                            name: this.addZhangForm.name,
                            type: 4,
                            child: [],
                            expand: false
                        };
                        this.chapters.push(chapter);
                    } else if (this.distinguishBtn === 1) {
                        let chapter = this.chapters[this.chapters.length - 1];
                        chapter.child.push({
                            name: this.addZhangForm.name,
                            type: 5,
                            child: []
                        });
                    }
                    this.$refs[formName].resetFields();
                    this.dialogAddZhang = false;
                } else {
                    return false;
                }
            });
        },
        saveData() {
            if (this.chapters.length === 0) {
                this.$message({
                    type: 'warning',
                    message: '请添加课程目录以及资源'
                });
                return false;
            }
            if (this.$store.state.undone) {
                this.$message({
                    type: 'warning',
                    message: '请完成课程章节的创建'
                });
                return false;
            }

            if (!this.$common.formatChapters(this.chapters)) {
                this.$message({
                    type: 'warning',
                    message: '课程目录只支持（章-节-资源）3层-层级结构！,请切换到拖拽模式，检查层级结构',
                    duration: 3000
                });
                return false;
            }

            if (!this.$common.checkChapters(this.chapters)) {
                this.$message({
                    type: 'warning',
                    message: '课程必须添加资源！',
                    duration: 3000
                });
                return false;
            }
            this.format(this.chapters);
            this.setIds(this.chapters);
            this.$emit('saveResource',this.chapters)
        },
        format(chapters) {
            let len = chapters.length
            for (let i = len; i >= 0; i--) {
                if (chapters[i] == null) {
                    chapters.splice(i, 1);
                } else {
                    this.format(chapters[i].child);
                }
            }
        },
        setIds(chapters){
            chapters.forEach((item, index) => {
                item.id = index + 1
                item.child.forEach((item1, index1) => {
                    item1.id = index1 + 1
                })
            })
            return chapters;
        },
        returnCourses() {
            this.$confirm('此操作当前页面数据不做保存, 是否继续?', '提示', {}).then(() => {
                this.$router.push('/admin/courseManage/index');
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消返回操作~',
                    duration: 1000
                });
            });
        },
        changeStep(val) {
            this.$emit('changeStep', val)
        },
    }
}